import React from 'react'
import PropTypes from 'prop-types'
import KpiCard from './KpiCard'
import KpiCardRow from './KpiCardRow'
import BellOnIcon from './icons/BellOnIcon'
import FaceIcon from './icons/FaceIcon'
import FlagIcon from './icons/FlagIcon'
import {
  alertStatus, formatInteger, formatNumber, formatPercent, gradeStatus, satisfactionStatus
} from './status'

// Shared metric row used by both the Statistics and Evolution pages.
// Pages fetch their own data and feed it as props; null values render as "--".
// Standard metric tooltips, shared so both pages read the same copy.
const SATISFACTION_TOOLTIP = 'Pourcentage de contrôles dont la note est supérieure ou'
  + ' égale au seuil de satisfaction, rapporté au nombre total de notes reçues.'
const ALERTS_TOOLTIP = 'Nombre d\'alertes déclenchées automatiquement lors d\'une'
  + ' anomalie détectée dans une des collectes.'
const CONTROLS_TOOLTIP = 'Les contrôles supplémentaires sont inclus.'

const KpiCardGroup = ({
  grade, satisfaction, controlsCount, alertsCount, gradeMax,
  showSatisfaction, hasAlertsConfigured, hasAdditionalAnswer, className
}) => {
  const gradeStatusValue = gradeStatus(grade, gradeMax)
  const satisfactionStatusValue = satisfactionStatus(satisfaction)

  return (
    <KpiCardRow className={className}>
      <KpiCard
        icon={<FaceIcon status={gradeStatusValue} />}
        label="Note globale"
        status={gradeStatusValue}
        suffix={Number.isFinite(grade) ? `/${gradeMax}` : null}
        value={formatNumber(grade)}
      />
      {showSatisfaction ? (
        <KpiCard
          icon={<FaceIcon status={satisfactionStatusValue} />}
          label="Taux de satisfaction"
          status={satisfactionStatusValue}
          tooltip={SATISFACTION_TOOLTIP}
          value={formatPercent(satisfaction)}
        />
      ) : null}
      <KpiCard
        icon={<FlagIcon />}
        label="Nombre de contrôles"
        tooltip={hasAdditionalAnswer ? CONTROLS_TOOLTIP : null}
        value={formatInteger(controlsCount)}
      />
      {hasAlertsConfigured ? (
        <KpiCard
          icon={<BellOnIcon />}
          label="Alertes déclenchées"
          status={alertStatus(alertsCount || 0)}
          tooltip={ALERTS_TOOLTIP}
          value={formatInteger(alertsCount)}
        />
      ) : null}
    </KpiCardRow>
  )
}

KpiCardGroup.propTypes = {
  alertsCount: PropTypes.number,
  className: PropTypes.string,
  controlsCount: PropTypes.number,
  grade: PropTypes.number,
  gradeMax: PropTypes.number.isRequired,
  hasAdditionalAnswer: PropTypes.bool,
  hasAlertsConfigured: PropTypes.bool.isRequired,
  satisfaction: PropTypes.number,
  showSatisfaction: PropTypes.bool
}

KpiCardGroup.defaultProps = {
  alertsCount: null,
  className: '',
  controlsCount: null,
  grade: null,
  hasAdditionalAnswer: false,
  satisfaction: null,
  showSatisfaction: true
}

export default KpiCardGroup
